export default __webpack_public_path__ + "static/media/opening04.437b61a0.jpg";